<section
  class="plan-card-mini-view"
  *ngIf="isMiniView"
  (mouseenter)="handleMouseEnter()"
  (mouseleave)="handleMouseLeave()"
>
  <p class="plan-card-mini-view-plan-name">{{ plan.name }}</p>
  <div *ngIf="plan.planId === currentPlan?.planId" class="plan-card-mini-view-current-plan-badge">
    <p>{{ 'Your current plan' | translate }}</p>
  </div>

  <ng-container *ngIf="plan.planId !== currentPlan?.planId">
    <ng-container *ngTemplateOutlet="upgradeButton"></ng-container>
  </ng-container>
</section>

<section
  class="plan-card"
  *ngIf="!isMiniView"
  [ngClass]="{
    'current-plan': plan.planId === currentPlan?.planId,
    'selected-plan': (isHovered | async)
  }"
  (mouseenter)="handleMouseEnter()"
  (mouseleave)="handleMouseLeave()"
>
  <header class="plan-card-header">
    <div class="plan-card-header-name">{{ plan.name }}</div>
    <div class="plan-card-header-tag" *ngIf="plan.tag">{{ plan.tag }}</div>
  </header>
  <main class="plan-card-main">
    <div class="plan-card-main-price">
      <div class="plan-card-main-price-value">
        <p
          class="plan-card-main-price-value-amount"
          *ngIf="plan.billingStrategy === BillingStrategy.CUSTOM_BASED; else priceTemplate"
        >
          {{ 'Custom' | translate }}
        </p>
        <ng-template #priceTemplate>
          <p class="plan-card-main-price-value-amount">
            ${{ plan.price | number: (isInteger(plan.price) ? '1.0-0' : '1.2-2') }}
          </p>
          <p class="plan-card-main-price-value-period">
            /{{
              plan.priceUnit ??
                (plan.billingFrequency === BillingFrequency.Monthly
                  ? ('month' | translate)
                  : ('year' | translate))
            }}
          </p>
        </ng-template>
      </div>
    </div>

    <div class="plan-card-main-content">
      <div *ngIf="plan.description" class="plan-card-main-content-description">
        <p>{{ plan.description }}</p>
      </div>

      <div
        *ngIf="plan.planId === currentPlan?.planId"
        class="plan-card-main-content-current-plan-badge"
      >
        <p>{{ 'Your current plan' | translate }}</p>
      </div>

      <ng-container *ngIf="plan.planId !== currentPlan?.planId">
        <ng-container *ngTemplateOutlet="upgradeButton"></ng-container>
      </ng-container>
    </div>
  </main>
  <footer class="plan-card-footer">
    <div class="plan-card-footer-item-header">
      <div class="plan-card-footer-discount-badge" *ngIf="plan.pricingPointDiscountLabel">
        {{ plan.pricingPointDiscountLabel }}
      </div>
      <p *ngIf="plan.planOfferingDescription">
        {{ plan.planOfferingDescription }}
        <span class="plan-card-footer-original-rate" *ngIf="plan.originalPriceRate">{{
          plan.originalPriceRate
        }}</span>
        <span *ngIf="plan.currentPriceRate"> {{ plan.currentPriceRate }}</span>
      </p>
    </div>
    <div *ngFor="let feature of plan.keyFeatures" class="plan-card-footer-item-content">
      <svg-icon [icon]="'check'" [width]="18" [height]="18"></svg-icon>
      <p>{{ feature }}</p>
    </div>
  </footer>
</section>

<ng-template #upgradeButton>
  <app-pencil-button
    *ngIf="plan.action === PlanAction.Upgrade"
    class="plan-card-main-content-button"
    [theme]="
      (isHovered | async) ? PencilButtonThemeEnum.PRIMARY : PencilButtonThemeEnum.SECONDARY_OUTLINE
    "
    data-name="settings-payment-plan-upgrade-switch-btn"
    [icon]="currentPlan ? 'compare_arrows' : 'arrow_upward'"
    [iconConfig]="{ type: 'mat-icon' }"
    [label]="currentPlan ? ('Change plan' | translate) : ('Upgrade' | translate)"
    (click)="initiateSubscriptionAction()"
  >
  </app-pencil-button>

  <app-pencil-button
    *ngIf="plan.action === PlanAction.ContactUs"
    class="plan-card-main-content-button"
    [theme]="
      (isHovered | async) ? PencilButtonThemeEnum.PRIMARY : PencilButtonThemeEnum.SECONDARY_OUTLINE
    "
    data-name="settings-payment-plan-contact-sales-btn"
    [icon]="'arrow_forward'"
    [iconConfig]="{ type: 'mat-icon' }"
    [label]="'Talk to Sales' | translate"
    (click)="openIntercom()"
  >
  </app-pencil-button>
</ng-template>
